const FansManage = () => import(/* webpackChunkName: 'wxfans' */ './fansManage');
const FansDetail = () => import(/* webpackChunkName: 'wxfans' */ './fansDetail');
const FansView = () => import(/* webpackChunkName: 'wxfans' */ './fansView');


const routes = [
  { path: '/wxfans/fansManage', component: FansManage },
  { path: '/wxfans/fansDetail', component: FansDetail },
  { path: '/wxfans/fansView', component: FansView },
];

export default routes;
